import { useLocalStorage } from "usehooks-ts";
import { ofetch } from 'ofetch';
import { message } from 'antd';
import { CreateThreadResponse, HistoryResponse, SimpleResponse, TokenResponse, TreadListResponse } from "./http.models";

// const BASE_URL = 'https://ai.zhijibao.net/api';
const BASE_URL = 'https://ai.linkedhi.cn/api';
// const BASE_URL = 'https://12e8f9b1.r34.cpolar.top';
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export type ApiActions = {
  getToken: () => string|null;
  setToken: (token: string) => void;
  loginApi: (phoneNumber: number, password: string,role: string) => Promise<boolean>;
  registerApi: (values: Record<string, any>)=> Promise<boolean>;
  logoutApi: () => void;
  getHistoryList: () => Promise<TreadListResponse>;
  createThread: () => Promise<CreateThreadResponse>;
  changeSessionTitle: (sessionId: string, title: string) => Promise<SimpleResponse>;
  getSessionHistory: (sessionId: string) => Promise<HistoryResponse>;
  removeSessionApi: (sessionId: string) => Promise<SimpleResponse>;
}

export default function ApiModel() {
  const [token, setToken, removeToken] = useLocalStorage<string|null>('token', null);
  function getToken(): string|null { return token };

  const loginApi = async (phoneNumber: number, password: string,role: string) => {
    try {
      // @ts-ignore
      const { code: code,data: data,msg: msg } = await ofetch<TokenResponse>('/alhuser/login', {
        method: 'POST',
        body: { phoneNumber, password,role},
        baseURL: BASE_URL,
        headers: {
          'Content-Type': 'application/json'
        },
        retry: 1,
        timeout: 10000
      });
      // setToken(code);
      if(code === 200){
        setToken(data.token);
        localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
        return true;
      }
      else{
        message.error(msg || '登录失败，请检查账号密码');
        console.error('登录失败:', msg);
        return false;
      }
    } catch (error) {
      console.error('登录失败:', error);
      return false;
    }
  };

  const registerApi = async (values: Record<string, any>) => {
    try {
      // @ts-ignore
      const { code: code,data: data,msg: msg } = await ofetch('/alhuser/register', {
        method: 'POST',
        body: values,
        baseURL: BASE_URL,
        headers: {
          'Content-Type': 'application/json'
        },
        retry: 1,
        timeout: 10000
      });
      if(code === 200){
        return true;
      }
      else{
        message.error(msg || '注册失败');
        console.error('注册失败:', msg);
        return false;
      }
    } catch (error) {
      console.error('注册失败:', error);
      return false;
    }
  };


  const logoutApi = () => setToken(null);

  async function request<T>(method: HttpMethod, url: string, data?: any): Promise<T> {
    try {
      return await ofetch(url, {
        method,
        body: data,
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json'
        },
        baseURL: BASE_URL,
        retry: 1,
        timeout: 10000,
        onResponseError: ({ response }) => {
          if (response.status === 401) {
            logoutApi();
          }
          throw response._data;
        }
      });
    } catch (error) {
      console.error(`HTTP请求失败: ${method} ${url}`, error);
      throw error;
    }
  }

  const getApi = <T>(url: string) => request<T>('GET', url);
  const postApi = <T>(url: string, data?: any) => request<T>('POST', url, data);
  const putApi =  <T>(url: string, data?: any) => request<T>('PUT', url, data);
  const deleteApi = <T>(url: string) => request<T>('DELETE', url);

  const getHistoryList = () => getApi<TreadListResponse>('https://ai.zhijibao.net/api/ai/user/history_list');
  const createThread = () => postApi<CreateThreadResponse>('https://ai.zhijibao.net/api/ai/user/thread');
  const changeSessionTitle = (sessionId: string, title: string) => putApi<SimpleResponse>(`https://ai.zhijibao.net/api/ai/chat/${sessionId}`, { title });
  const getSessionHistory = (sessionId: string) => getApi<HistoryResponse>(`https://ai.zhijibao.net/api/ai/history/${sessionId}`);
  const removeSessionApi = (sessionId: string) => deleteApi<SimpleResponse>(`https://ai.zhijibao.net/api/ai/chat/${sessionId}`);

  const getUserInfo = (userId:number) => getApi<Record<any, any>>(`/users/${userId}`);

  const getDoctorQrCode = (userId:number) => getApi<Record<any, any>>(`/doctors/qrcode?userId=${userId}`);

  const getAgentQrCode = (userId:number) => getApi<Record<any, any>>(`/agents/qrcode?userId=${userId}`);

  const updateUser = (userId:number,userVO: String) => putApi<Record<any, any>>(`/users/${userId}`,userVO);

  const getClientsPatientList = (userId:number,userName:string) => getApi<Record<any, any>>(`/agents/clients?agentId=${userId}&userName=${userName}`);

  const getJSSDKConfig = (url:string) => getApi<Record<any, any>>(`/wx/js/jssdk-config?url=${url}`);

  const getCode = (code:string,userId:number) => getApi<Record<any, any>>(`/wechat/openid?code=${code}`+`&userId=${userId}`);

  const getClueClientList = (pageVO : Record<any, any>) => getApi<Record<any, any>>(`/clue/getClueClientList?pageNum=${pageVO.pageNum}&pageSize=${pageVO.pageSize}`);

  const createClueOrder = (data : Record<any, any>) => postApi<Record<any, any>>(`/clue/createClueOrder`,data);

  const payOrder = (data : Record<any, any>) => postApi<Record<any, any>>(`/clue/payOrder`,data);

  const bindAgent = (agentId:number,clientId:number) => postApi<Record<any, any>>(`/agents/bind?agentId=${agentId}`+`&clientId=${clientId}`);

  const getClueOrderList = (pageVO : Record<any, any>) => getApi<Record<any, any>>(`/clue/getClueOrderList?pageNum=${pageVO.pageNum}`+`&pageSize=${pageVO.pageSize}`);

  return {
    getToken,
    setToken,
    loginApi,
    logoutApi,
    getHistoryList,
    createThread,
    changeSessionTitle,
    getSessionHistory,
    removeSessionApi,
    registerApi,
    getUserInfo,
    getDoctorQrCode,
    getAgentQrCode,
    updateUser,
    getClientsPatientList,
    getJSSDKConfig,
    getCode,
    getClueClientList,
    createClueOrder,
    payOrder,
    bindAgent,
    getClueOrderList
  } as ApiActions;
}
